<template>
    <v-dialog
        v-model="$store.state.dispatch.unknownOrigins"
        hide-overlay
        persistent
        max-width="700px"
        transition="dialog-bottom-transition"
    >
        <v-card>
            <v-card-title>
                <p style="margin: 0 auto;">Unknown Origins</p>
            </v-card-title>

            <v-alert
                border="top"
                colored-border
                type="info"
                elevation="2"
                color="#8E44AD"
            >
                The following orders are currently in the Shift of another Driver (on his tablet). To be able to send this Shift, first of all you have to do a "Revise" to the Origin Driver, and then these orders will be "released".
            </v-alert>

            <template>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-center">
                                    Date
                                </th>                                
                                <th class="text-center">
                                    OrderID
                                </th>
                                <th class="text-center">
                                    ShiftDetail
                                </th>
                                <th class="text-center">
                                    Origin Driver
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="org in UnknownOrigins"
                                :key="org.ShiftDetail"
                            >
                                <td class="text-center">{{ org.Date }}</td>
                                <td class="text-center">{{ org.OrderID }}</td>
                                <td class="text-center">{{ org.ShiftDetail }}</td>
                                <td class="text-center">{{ org.DriverName }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </template>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="#8E44AD"
                    text
                    @click="$store.state.dispatch.unknownOrigins = false"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['UnknownOrigins'],
    components: {
    },
    data: function () {
        return {
        }
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style>
/* Styles here */
</style>